import * as React from "react";
import Button from "@mui/material/Button";
import LogoImg from "assets/icons/logo.svg";
import AvatarImg from "assets/icons/avatar.svg";
import { useAuthContext } from "contexts/Auth";
import { useCustomerContext } from "contexts/Customer";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { navigate, useLocation } from "@reach/router";
import "./style.scss";

export const Header = () => {
  const { firstName, lastName, logout } = useAuthContext();
  const { clearCustomerData } = useCustomerContext();
  const location = useLocation();
  const fullName = firstName + " " + lastName;
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const onLogout = async () => {
    setAnchorEl(null);
    await logout();
    await clearCustomerData();
    navigate("/");
  };

  return (
    <div className="header">
      <div className="header-logo">
        <img src={LogoImg} alt="logo" />
      </div>
      <div className="header-space"></div>
      <div className="header-user" onClick={() => handleClick}>
        {location.pathname != "/" && (
          <>
            <span>Hello, {fullName}</span>
            <Button
              id="basic-button"
              size="small"
              aria-controls={open ? "basic-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              onClick={handleClick}
            >
              <img src={AvatarImg} alt="avatar" />
            </Button>
            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              MenuListProps={{
                "aria-labelledby": "basic-button",
              }}
              transformOrigin={{ horizontal: "right", vertical: "top" }}
              anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            >
              <MenuItem onClick={onLogout}>Logout</MenuItem>
            </Menu>
          </>
        )}
      </div>
    </div>
  );
};
